import { render } from "./APKManagement.vue?vue&type=template&id=5c5d14ba&scoped=true"
import script from "./APKManagement.vue?vue&type=script&lang=js"
export * from "./APKManagement.vue?vue&type=script&lang=js"

import "./APKManagement.vue?vue&type=style&index=0&id=5c5d14ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5d14ba"]])

export default __exports__